var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthersitesRedMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.199999999999996,
    height: 56.00000000000001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 58,
    width: 51.2,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fb404b",
    cx: 24.560976,
    cy: 24.648084,
    id: "svg_2",
    rx: 24,
    ry: 24,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(179.84815979003906 24.56873321533203,49.56330108642578) ",
    stroke: "#fb404b",
    id: "svg_1",
    d: "m17.657192,52.490952l6.91154,-5.855307l6.91154,5.855307l-13.82308,0z",
    fill: "#fb404b",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-5.403212070465088 18.546949386596726,50.33517074584961) ",
    stroke: "#000000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_5",
    y2: 56.023971,
    x2: 24.385745,
    y1: 44.646408,
    x1: 12.708186,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(93.25433349609375 30.616111755371083,50.30661773681641) ",
    stroke: "#000000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_4",
    y2: 56.387509,
    x2: 36.085227,
    y1: 44.225758,
    x1: 25.14703,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersitesRedMarker);
export default __webpack_public_path__ + "static/media/othersites-red-marker.18a4c68df9305ee61ab411df42a3130e.svg";
export { ForwardRef as ReactComponent };